module.exports = __webpack_public_path__ + "img/_blog5.c4454f1b.jpg";